export enum MessageActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    messageNotice = 'messageNotice',
    variableSettings = 'variableSettings',
}